// extracted by mini-css-extract-plugin
export default {"loadingIcon":"routingContainer_loadingIcon__RWiMG","loadingContainer":"routingContainer_loadingContainer__iW7De"};